import { Injectable } from "@angular/core";
import
{
    BidQuoteViewModel,
    ExecutionResult,
    IDocument,
    ISearchCriteria,
    LookupCriteria,
    PurchaseOrderInvoiceViewModel,
    RequisitionApprovalContext,
    RequisitionApprovalResult,
    RequisitionApprovalsContext,
    RequisitionApprovalsResponse,
    RequisitionItemViewModel,
    RequisitionLookupViewModel,
    RequisitionSaveViewModel,
    RequisitionSearchViewModel,
    RequisitionViewModel,
    TcmDocumentContext,
} from "@tylertech/tyler-api-types";
import { RequisitionApprovalService } from "./requisitionApprovalService.g";
import { RequisitionLookupService } from "./requisitionLookupService.g";
import { RequisitionSearchService } from "./requisitionSearchService.g";
import { RequisitionService } from "./requisitionService.g";

/**
 * @deprecated Use RequisitionService, RequisitionSearchService, RequisitionApprovalService, or RequisitionLookupService.
 */
@Injectable()
export class LegacyRequisitionService
{
    constructor(
        private readonly $requisitionService: RequisitionService,
        private readonly $requisitionSearchService: RequisitionSearchService,
        private readonly $requisitionApprovalService: RequisitionApprovalService,
        private readonly $requisitionLookupService: RequisitionLookupService
    ) { }

    CanAdd(): Promise<ExecutionResult<boolean>>
    {
        return this.$requisitionService.CanAdd();
    }

    CanUserApproveRequisitions(
        context: RequisitionApprovalsContext
    ): Promise<ExecutionResult<RequisitionApprovalsResponse>>
    {
        return this.$requisitionApprovalService.CanUserApproveRequisitions(context);
    }

    Delete(id: string): Promise<ExecutionResult<boolean>>
    {
        return this.$requisitionService.Delete(id);
    }

    ExportRequisitionForm(pReqId: string): Promise<IDocument>
    {
        return this.$requisitionService.ExportRequisitionForm(pReqId);
    }

    Get(requisitionId: string): Promise<ExecutionResult<RequisitionViewModel>>
    {
        return this.$requisitionService.Get(requisitionId);
    }

    GetBidQuotes(requisitionId: string): Promise<BidQuoteViewModel[]>
    {
        return this.$requisitionService.GetBidQuotes(requisitionId);
    }

    GetItems(requisitionId: string): Promise<RequisitionItemViewModel[]>
    {
        return this.$requisitionService.GetItems(requisitionId);
    }

    GetReqInvoices(requisitionId: string): Promise<PurchaseOrderInvoiceViewModel[]>
    {
        return this.$requisitionService.GetReqInvoices(requisitionId);
    }

    GetTcmUrl(context: TcmDocumentContext<RequisitionViewModel>): Promise<ExecutionResult<string>>
    {
        return this.$requisitionService.GetTcmUrl(context);
    }

    Lookup(pCriteria: LookupCriteria): Promise<ExecutionResult<RequisitionLookupViewModel[]>>
    {
        return this.$requisitionLookupService.Lookup(pCriteria);
    }

    RequisitionNumberIsAvailable(pRequisitionNumber: string): Promise<boolean>
    {
        return this.$requisitionService.RequisitionNumberIsAvailable(pRequisitionNumber);
    }

    Save(requisitionSave: RequisitionSaveViewModel): Promise<ExecutionResult<RequisitionSaveViewModel>>
    {
        return this.$requisitionService.Save(requisitionSave);
    }

    SaveRequisitionApprovals(approvalContext: RequisitionApprovalContext): Promise<ExecutionResult<RequisitionApprovalResult>>
    {
        return this.$requisitionApprovalService.SaveRequisitionApprovals(approvalContext);
    }

    SearchRequisitionsReadyForPurchaseOrder(criteria: ISearchCriteria<RequisitionSearchViewModel>): Promise<ISearchCriteria<RequisitionSearchViewModel>>
    {
        return this.$requisitionSearchService.SearchRequisitionsReadyForPurchaseOrder(criteria);
    }
}
